import { Component, OnInit, ViewChild, Renderer2, ContentChild, AfterViewInit, AfterViewChecked, ChangeDetectorRef, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import Utils from '../../../app/helpers/Utils';
import {VgApiService} from '@videogular/ngx-videogular/core';
// import { MatVideoComponent } from 'mat-video/lib/video.component';

@Component({
    selector: 'app-videotraining',
    templateUrl: './videotraining.component.html',
    styleUrls: ['./videotraining.component.scss'],
    standalone: false
})
export class VideoTrainingComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @Output() onFinish = new EventEmitter();
  @ViewChild('media') myVideo: any;
  public video: any;
  public bookType: string;
  api:VgApiService;
  isDisabled = null;
  isMobile = false;
  testmode = false;
  urlInfo = '';
  videoType = 'video/webm';
  private previousVideoUrl: string = '';
  private previousTrainingType: string = '';

  isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  videoMuted = true; // Always start muted — required for autoplay on iOS in iframes

  ngAfterViewChecked(): void {
    this.checkForTrainingTypeChange();
    this.cdRef.detectChanges();
  }

  constructor(
    private router: Router,
    private deviceService: DeviceDetectorService,
    private cdRef: ChangeDetectorRef
    ) { }
  ngAfterViewInit(): void {
    this.urlInfo = sessionStorage.getItem('flexusEnterUrl');
    console.log(this.urlInfo);
    let video = this.myVideo.nativeElement; //document.querySelector('#singleVideo') as HTMLVideoElement;
    if(video != null){
      console.log(video);
      // Keep video muted for autoplay to work across all browsers
      if(this.urlInfo !== null || this.isIOS){
        //video.muted = true;
        this.videoMuted = true;
      }
      //video.muted = true;
      // Try to play, catch promise rejection
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.log('Autoplay prevented:', error);
          // Autoplay was prevented, video will need user interaction
        });
      }
    }
    if ((environment.environmentName === 'test' && this.bookType !== 'SKFRDriver') && !!sessionStorage.getItem(environment.sessionIsYMUser)) {
      setTimeout(() =>
      {
        this.router.navigate(['/trainingfiles']);
      },
      3000);
    }
    if ((environment.environmentName === 'skfrtest' || (this.bookType === 'SKFRDriver' && environment.environmentName === 'test')) && !!sessionStorage.getItem(environment.sessionIsYMUser)) {
      this.testmode = true;

    }
  }

  onClick() {
    if(Utils.getBookType() === 'SKFRDriver'){
      if(!!sessionStorage.getItem(environment.sessionIsYMUser)) {
        this.router.navigate(['/exam']);
        return;
      }
      this.router.navigate(['/userdata']);
      return;
    }
    if(Utils.getBookType() === 'KBW' && sessionStorage.getItem(environment.sessionSelectedExam) === '30')
    {
      this.router.navigate(['/userdata']);
      return;
    }
    this.router.navigate(['/trainingfiles']);
  }

  ngOnInit() {
    this.bookType = Utils.getBookType();
    this.isMobile = this.deviceService.isMobile();
    this.video = this.selectVideoLang();
    this.previousVideoUrl = this.video;
    this.previousTrainingType = this.getCurrentTrainingType();
    if (Utils.getBookType() === 'SKFRDriver') {
      this.isDisabled = true;
    }
  }




  onPlayerReady(api: VgApiService) {
    this.api = api;

    // Subscribe to events first
    this.api.getDefaultMedia().subscriptions.ended.subscribe(
      () => {
          // this.api.getDefaultMedia().currentTime = 0;
          // this.nextVideo();
         this.isDisabled = false;
      }
    );
    this.api.getDefaultMedia().subscriptions.error.subscribe(
      (event) => {
        this.onVideoError(event);
      }
    );

    // Try to play with error handling for iOS
    try {
      this.playVideo();
    } catch (error) {
      console.log('Play error:', error);
    }
  }

  onVideoError(event: any) {
    console.error('Video loading error:', event);
    console.error('Video URL:', this.video);
    console.error('Video type:', this.videoType);
    // Optional: You can add user-friendly error messaging here
  }
  playVideo() {
    this.api.currentTime = 0;
    this.api.play();
  }
  nextVideo() {
    this.onFinish.emit();
  }

  onVideoClick() {
    // Unmute video when user clicks/taps (works for all browsers)
    if (this.myVideo && this.myVideo.nativeElement) {
      const video = this.myVideo.nativeElement;
      if (video.muted) {
        video.muted = false;
        this.videoMuted = false;
      }
    }
  }

  getCurrentTrainingType(): string {
    const bookType = Utils.getBookType();
    if (bookType === 'KBW') {
      return sessionStorage.getItem(environment.sessionSelectedExam) || '';
    } else if (bookType === 'SKFRDriver') {
      return sessionStorage.getItem(environment.sessionSelectedTrainingFile) || '';
    }
    return '';
  }

  checkForTrainingTypeChange(): void {
    const currentTrainingType = this.getCurrentTrainingType();

    // Check if training type changed
    if (currentTrainingType && currentTrainingType !== this.previousTrainingType) {
      console.log('Training type changed from', this.previousTrainingType, 'to', currentTrainingType);

      // Update video URL
      const newVideoUrl = this.selectVideoLang();

      if (newVideoUrl !== this.previousVideoUrl) {
        this.video = newVideoUrl;
        this.previousVideoUrl = newVideoUrl;
        this.previousTrainingType = currentTrainingType;

        // Reset player state
        if (Utils.getBookType() === 'SKFRDriver') {
          this.isDisabled = true;
        }

        // Reload video if API is ready
        if (this.api && this.myVideo) {
          setTimeout(() => {
            const video = this.myVideo.nativeElement;
            if (video) {
              video.load(); // Force reload of video source

              // Keep video muted for autoplay to work across all browsers
              video.muted = true;
              this.videoMuted = true;

              const playPromise = video.play();
              if (playPromise !== undefined) {
                playPromise.catch(error => {
                  console.log('Autoplay prevented after reload:', error);
                });
              }
            }
          }, 100);
        }
      }
    }
  }




  selectVideoLang(): string {
    const lang = sessionStorage.getItem(environment.sessionLang);
    let videoLink;
    const bookType = Utils.getBookType();
    // console.log(bookType);
    switch(bookType) {
      case 'KBK': {
        videoLink = this.kbkBook(lang);
        break;
      }
      case 'SKFRDriver':{
        videoLink = this.kfrDriverBook(lang);
        break;
      }
      case 'KBW':{
        videoLink = this.kbwBook(lang);
        break;
      }
      default: {
        videoLink = this.kbkBook(lang);
      }
    }
    let ext = 'webm'
    if(bookType === 'KBW' || bookType === 'KBK'){
      ext = 'mp4';
      this.videoType = 'video/mp4';
    } else {
      this.videoType = 'video/webm';
    }
    let fullVideoLink = `https://skplpublicstorage.blob.core.windows.net/safetyvideo/${videoLink}.${ext}`;
    return fullVideoLink;
  }
  kbwBook(lang) : string {
    let trainingType = sessionStorage.getItem(environment.sessionSelectedExam);
    let videoLink;
    let videoType = trainingType === '6' ? 'CONTRACT' : trainingType === '30' ? 'GUEST' : '';
    videoLink = `${videoType}_${lang.substring(0,2).toUpperCase()}`
    return videoLink;
  }
  kfrDriverBook(lang) : string {
    let videoLink;
    let trainingType = sessionStorage.getItem(environment.sessionSelectedTrainingFile);
    switch(trainingType){
      case '61':{
        //videoLink = 'kIcD4IbcSmM';
        videoLink = 'QUAI_A_03_2022';
        break;
      }
      case '62':{
        videoLink = 'QUAI_B_03_2022';
        break;
      }
      case '63':{
        videoLink = 'QUAI_C_03_2022';
        break;
      }
      case '64':{
        videoLink = 'QUAI_D_03_2022';
        break;
      }
      case '65':{
        videoLink = 'QUAI_E_03_2022';
        break;
      }
      case '66':{
        videoLink = 'visiteurs_fr';
        break;
      }
      case '67':{
        videoLink = 'rondins_fr';
        break;
      }
      case '68':{
        videoLink = 'vrac_fr';
        break;
      }
      case '69':{
        videoLink = 'vrac_fr';
        break;
      }
      case '70':{
        videoLink = 'visiteurs_fr';
        break;
      }
      default:{
        videoLink = 'QUAI_A_03_2022';
      }
    }
    // console.log(trainingType);
    // console.log(videoLink);
    return videoLink;
  }
  kbkBook(lang) : string {
    let videoLink;
    switch (lang) {
      case 'pl-PL': {
        videoLink = 'KBK_SKPL_PL';
        //videoLink = 'S10dxIh4dWM';
        break;
      }
      case 'en-GB': {
        videoLink = 'KBK_SKPL_EN';
        // videoLink = 'ebQm2y7ycwk';
        break;
      }
      case 'de-DE': {
        videoLink = 'KBK_SKPL_DE';
        // videoLink = 'TdsfIkK-qMo';
        break;
      }
      case 'ru-RU': {
        videoLink = 'KBK_SKPL_RU';
        // videoLink = 'XJFhuFYaLBM';
        break;
      }
      case 'hu-HU': {
        videoLink = 'KBK_SKPL_EN';
        // videoLink = 'ebQm2y7ycwk';
        break;
      }
      case 'bg-BG': {
        videoLink = 'KBK_SKPL_EN';
        // videoLink = 'ebQm2y7ycwk';
        break;
      }
      case 'ro-RO': {
        videoLink = 'KBK_SKPL_EN';
        // videoLink = 'ebQm2y7ycwk';
        break;
      }
      case 'hr-HR': {
        videoLink = 'KBK_SKPL_EN';
        // videoLink = 'ebQm2y7ycwk';
        break;
      }
      case 'uk-UA': {
        videoLink = 'KBK_SKPL_EN';
        // videoLink = 'XJFhuFYaLBM';
        break;
      }
      default: {
        videoLink = 'KBK_SKPL_PL';
        // videoLink = 'S10dxIh4dWM';
      }
    }
    return videoLink;
  }
}
